// Models
import { Temporal } from "temporal-polyfill-lite";
/**
 * Plan Calendar settings.
 */ export class Calendar {
    getClone() {
        // Temporal.PlainTime is immutable, so the references can be shared safely.
        return new Calendar({
            workDayDefaults: {
                startTime: this.workDayDefaults.startTime,
                endTime: this.workDayDefaults.endTime
            },
            timeZone: this.timeZone
        });
    }
    setProperty(key, value) {
        const clone = this.getClone();
        clone[key] = value;
        return clone;
    }
    forSerialization() {
        return {
            workDayDefaults: {
                startTime: this.workDayDefaults.startTime.toString(),
                endTime: this.workDayDefaults.endTime.toString()
            },
            timeZone: this.timeZone
        };
    }
    forCreate() {
        return this.forSerialization();
    }
    static fromResource(resource) {
        return new Calendar({
            workDayDefaults: {
                startTime: Temporal.PlainTime.from(resource.workDayDefaults.startTime),
                endTime: Temporal.PlainTime.from(resource.workDayDefaults.endTime)
            },
            timeZone: resource.timeZone
        });
    }
    constructor(propertyBag = {}){
        this.workDayDefaults = {
            startTime: propertyBag.workDayDefaults?.startTime ?? Calendar.DEFAULT_START_TIME,
            endTime: propertyBag.workDayDefaults?.endTime ?? Calendar.DEFAULT_END_TIME
        };
        this.timeZone = propertyBag.timeZone ?? Calendar.DEFAULT_TIMEZONE;
    }
}
Calendar.DEFAULT_START_TIME = Temporal.PlainTime.from("09:00:00.0000000");
Calendar.DEFAULT_END_TIME = Temporal.PlainTime.from("17:00:00.0000000");
Calendar.DEFAULT_TIMEZONE = "Etc/UTC";
